import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPngToJpgConfig } from '@/data/landingConfig/landingPngToJpgConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PngToJpg } from './schemaObject';

interface Props {}
const PngToJpgConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PngToJpg} />
			<LandingTemplate
				data={landingPngToJpgConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default PngToJpgConverter;
